export default {
    methods: {
        getPublicCatalogLinkByBrand(brandIds) {
            let brandParams = window.$.param({ brands: brandIds })
            return `/catalog?${brandParams}`
        }
    }
}
